module.exports = __webpack_public_path__ + "img/signature.2e57d1bb.svg";